import React from 'react';
import wImg from '../../images/about/about_image_5.webp'
import sIcon1 from '../../images/icons/icon_check_2.svg'
import sIcon2 from '../../images/icons/icon_leaf.svg'
import sIcon3 from '../../images/icons/icon_box.svg'
import sIcon4 from '../../images/icons/icon_receipt_add.svg'

const Policy = [
    {
        title: 'Veiligheid voorop',
        icon: sIcon1,
    },
    {
        title: 'Schaalbare Beveiliging',
        icon: sIcon2,
    },
    {
        title: 'Duidelijke communicatie',
        icon: sIcon3,
    },
    {
        title: 'Transparente kosten',
        icon: sIcon4,
    },



]


const WhyUs = (props) => {

    return (
        <section className="service_section section_space ">
            <div className="container">
                <div className="row align-items-center justify-content-lg-between">
                    <div className="col-lg-6">
                        <div className="image_wrap">
                            <img src={wImg} alt="Techco - Start"/>
                        </div>
                    </div>
                    <div className="col-lg-6">
                        <div className="ps-lg-5">
                            <div className="heading_block">
                                <h2 className="heading_text mb-0">
                                    Maar er is hoop
                                </h2>
                                <p>
                                    Onze missie bij Praeventor is om de trend van cyberbedreigingen om te keren en digitale veiligheid voor iedereen toegankelijk te maken. Door de complexiteit van beveiliging eenvoudiger en transparanter te maken, nemen we de barrières weg die bedrijven weerhouden om hun digitale omgeving effectief te beschermen. We creëren bewustzijn, bieden praktische tools en begeleiden organisaties om proactief te handelen tegen cyberdreigingen. Samen bouwen we aan een toekomst waarin cyberveiligheid een recht en geen luxe is.
                                </p>
                            </div>
                            <ul className="service_facilities_group unordered_list">
                                {Policy.map((policy, pitem) => (
                                    <li key={pitem}>
                                        <strong className="iconbox_block layout_icon_left">
                                            <span className="iconbox_icon">
                                                <img src={policy.icon} alt="Dollar SVG Icon" />
                                            </span>
                                            <span className="iconbox_content">
                                                <strong className="iconbox_title mb-0">{policy.title}</strong>
                                            </span>
                                        </strong>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default WhyUs;